import api from '../../../api'

const defaultPrintMachine = () => {
  return {
    id: null,
    name: '',
    printWidth: null,
    printHeight: null,
    printPreWidth: null,
    printPreHeight: null,
    printPreSize: null,
    currencyRate: null,
    vat: null,
    withoutVat: false,
    multiplier: null,
    description: null,
    enabled: true
  }
}

export default {
  name: 'PrintMachineCard',
  props: {
    printMachineId: {
      default: null
    }
  },
  data: () => {
    return {
      printMachine: null,
      isInEdit: false,
      printMachineForEdit: defaultPrintMachine()
    }
  },
  methods: {
    loadPrintMachineData () {
      api.get.printMachine(this.pmId).then(resp => {
        this.printMachine = resp.data.data.printMachine
      })
    },
    closeCard () {
      this.$router.push({ path: '/settings/print-machines' })
    },
    editPrintMachine () {
      if (this.pmId) {
        Object.assign(this.printMachineForEdit, this.printMachine)
        this.printMachineForEdit.printPreSize = this.printMachine.printPreWidth
      } else {
        Object.assign(this.printMachineForEdit, defaultPrintMachine())
      }
      this.isInEdit = true
    },
    cancelEdit () {
      if (!this.pmId) {
        this.closeCard()
      }
      this.isInEdit = false
    },
    deletePrintMachine () {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              api.get.deletePrintMachine(this.pmId).then(() => {
                this.closeCard()
                this.$modal.hide('dialog')
                this.$eventBus.$emit('updatePrintMachines')
              })
            }
          }
        ]
      })
    },
    saveAfterEdit () {
      this.printMachineForEdit.printPreHeight = this.printMachineForEdit.printPreSize
      this.printMachineForEdit.printPreWidth = this.printMachineForEdit.printPreSize

      if (this.printMachineForEdit.withoutVat) {
        this.printMachineForEdit.vat = 0
      }

      if (this.pmId) {
        api.post
          .editPrintMachine(this.pmId, this.printMachineForEdit)
          .then((resp) => {
            this.printMachine = resp.data.data.printMachine
            this.cancelEdit()
            this.$eventBus.$emit('updatePrintMachines')
          })
          .catch(() => {
            this.cancelEdit()
          })
      } else {
        api.post
          .addPrintMachine(this.printMachineForEdit)
          .then(resp => {
            this.printMachine = resp.data.data.printMachine
            this.cancelEdit()
            this.$eventBus.$emit('updatePrintMachines')
          })
          .catch(() => {
            this.cancelEdit()
          })
      }
    }
  },
  watch: {
    printMachineId: function (val) {
      if (+val) {
        this.isInEdit = false
        this.loadPrintMachineData(val)
      } else {
        this.editPrintMachine()
      }
    }
  },
  computed: {
    pmId () {
      return +this.printMachineId
    },
    printMachineSize () {
      return `${this.printMachine.printWidth}x${
        this.printMachine.printHeight
        }мм`
    },
    printMachinePreSize () {
      return `${this.printMachine.printPreWidth}мм`
    }
  },
  created () {
    if (this.pmId) {
      this.isInEdit = false
      this.loadPrintMachineData(this.pmId)
    } else {
      this.editPrintMachine()
    }
  }
}
